import React, { useEffect, useMemo, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { _T } from 'appI18n';
import { useTourAccmmdVariants, useTourDescription, useTourVariant } from '../../../../TourSearch/store/TourDescriptionStore';
import AsyncLoadError from '../AsyncLoadError';
import HotelRoomFilters from './HotelRoomFilters';
import HotelRoomVariants, { HotelRoomVariantsSkeleton } from './HotelRoomVariants';
function convertTourAccommodationsToRoomDescriptions(accmmds) {
    const grouping = accmmds.reduce((acc, x) => {
        const id = `${x.accomodation.roomTypeId},${x.accomodation.roomCategoryId}`;
        if (!(id in acc))
            acc[id] = { description: x.accomodation.description, variants: [] };
        acc[id].variants.push(x);
        return acc;
    }, {});
    return Object.values(grouping);
}
export default function HotelRoomVariantsContainer({ isFrame, hotelIndex }) {
    const [ref, inView] = useInView({ rootMargin: '100px 0px', initialInView: false });
    const [{ accmmdVariants, initialized, loading, errors }, actions] = useTourAccmmdVariants(isFrame);
    const [{ tourVariant }] = useTourVariant(isFrame);
    const [{ tourDescription: { currency }, hash }] = useTourDescription(null, isFrame);
    const [immediateConfirm, setImmediateConfirm] = useState(false);
    const rooms = useMemo(() => accmmdVariants && accmmdVariants[hotelIndex] ? convertTourAccommodationsToRoomDescriptions(accmmdVariants[hotelIndex]) : [], [accmmdVariants, hotelIndex]);
    const roomsFiltered = useMemo(() => rooms.map(x => !immediateConfirm ? x : Object.assign(Object.assign({}, x), { variants: x.variants.filter(v => v.accomodation.immediateConfirm) })).filter(x => !!x.variants.length), [rooms, immediateConfirm]);
    const handleFilterApplied = (immediateConfirm) => setImmediateConfirm(immediateConfirm);
    // Загрузка размещений при скролле во вьюпорт.
    useEffect(() => {
        if (!inView || initialized || loading)
            return;
        actions.loadAccommodationVariants();
    }, [inView]);
    const isReady = initialized && !loading;
    return React.createElement("div", { ref: ref },
        React.createElement(HotelRoomFilters, { immediateConfirm: immediateConfirm, disabled: !isReady, onFilterApplied: handleFilterApplied }),
        (() => {
            if (errors.length)
                return React.createElement(AsyncLoadError, { errorText: _T.TOUR_ERROR_LOADING_ACCOMMODATION_VARIANTS });
            if (!isReady || !tourVariant)
                return React.createElement(HotelRoomVariantsSkeleton, { count: 2 });
            return React.createElement(HotelRoomVariants, { rooms: roomsFiltered, basePrice: tourVariant.price, basePriceCurrency: currency, disabled: !isReady, isFrame: isFrame, hash: hash });
        })());
}
